<template>
  <btn
    type="button"
    class="btn btn-primary w-100"
    @click="setOrder"
    :disabled="orderPending"
    >Zamawiam i płacę</btn
  >
</template>

<script>
import { RepositoryFactory } from '../../repositories/RepositoryFactory';
import { DataLayerManager } from '@/utils/DataLayerManager';

const configElement = document.getElementById('config');
const config = JSON.parse(configElement.innerHTML);

const shop = RepositoryFactory.get('order');

export default {
  name: 'OrderButton',
  data() {
    return {
      orderPending: false,
    };
  },
  computed: {
    editedOrderId() {
      return config.order_id;
    },
  },
  methods: {
    setOrder() {
      this.orderPending = true;
      DataLayerManager.pushCheckoutStep5Event();
      DataLayerManager.pushButtonOrderClickEvent();
      const stateWithoutAnalyticsData = this.getStateWithoutAnalyticsData();

      const orderSetter = this.editedOrderId
        ? state => shop.editOrder(this.editedOrderId, state)
        : state => shop.setOrder(state);

      orderSetter(stateWithoutAnalyticsData)
        .then((response) => {
          DataLayerManager.pushPurchaseEvent(response.data.orderId);
          this.$store.dispatch('delivery/reset');
          this.$store.dispatch('confection/resetConfection');
          this.$store.dispatch('virtualCard/reset');
          this.$store.dispatch('cart/reset');
          this.$store.dispatch('resetAllProducts');
          this.clearStorage();
          window.location.href = response.data.orderUrl;

          this.orderPending = false;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.orderPending = false;
        });
    },
    getStateWithoutAnalyticsData() {
      /* eslint-disable no-param-reassign */
      const newState = structuredClone(this.$store.state);
      newState.delivery.products.forEach(
        product => delete product.analyticsData,
      );
      if (newState.products.all.length === 0) return newState;
      newState.products.all.products.forEach((product) => {
        delete product.analyticsData;
        if (product.confection && product.confection.length > 0) {
          product.confection.forEach(
            confection => delete confection.analyticsData,
          );
        }
        if (product.confectionService && product.confectionService.length > 0) {
          product.confectionService.forEach(
            confectionService => delete confectionService.analyticsData,
          );
        }
      });
      return newState;
      /* eslint-enable no-param-reassign */
    },
    clearStorage() {
      const storageKeyName = JSON.parse(window.config.innerHTML).product;
      window.localStorage.getItem(storageKeyName);
      window.localStorage.removeItem(storageKeyName);
    },
  },
};
</script>

<style>
</style>
